// 从localStorage获取权限列表
const getPermissionList = () => {
  const permissionList = localStorage.getItem('permissionList')
  return permissionList ? JSON.parse(permissionList) : []
}

// 检查权限是否存在
export const hasPermission = (permission) => {
  const permissionList = getPermissionList()
  return permissionList.includes(permission)
}

export default {
  install(Vue) {
    // 注册一个全局自定义指令 `v-permission`
    Vue.directive('permission', {
      // 只在绑定元素插入父节点时调用一次
      inserted(el, binding) {
        const permission = binding.value
        // 如果没有权限，则移除元素
        if (!hasPermission(permission)) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      }
    })
  }
} 